import { AuthService } from 'phoenix/services';
export interface AuthUriFilter{
    (uri:string):string;
}

export function AuthUriFilter(pxAuthService:AuthService):AuthUriFilter{
    return function(uri:string){
        if(!angular.isDefined(uri) || uri === null || uri.length < 1){
            return '';
        }

        let authKey = pxAuthService.token.type === 'Bearer' ? 'access_token' : 'auth';
        let parts = uri.split('?');
        let queryString = parts[1] || '';
        uri = parts[0];
        
        if(queryString.length > 0){
            queryString += '&';
        }
        queryString += `${authKey}=${pxAuthService.token.value}`;
          
        return `${uri}?${queryString}`;
    };
}

AuthUriFilter.$inject = [
    'pxAuthService'
];


// WEBPACK FOOTER //
// ./src/phoenix/filters/authUri.ts